/**
 * Browser-side configuration.
 *
 * Only VITE_* values live here. Any value in this module ends up in the public
 * bundle, so it must never contain a secret. Runtime plan entitlements are
 * rendered from the server response, never from these constants.
 */

export interface WebConfig {
  apiBaseUrl: string;
  supabaseUrl: string;
  supabaseAnonKey: string;
  devAuthEnabled: boolean;
  siteUrl: string;
  supabaseConfigured: boolean;
}

function readEnv(value: string | undefined, fallback = ''): string {
  return (value ?? fallback).trim();
}

function isTruthy(value: string): boolean {
  return value.toLowerCase() === 'true' || value === '1';
}

const apiBaseUrl = readEnv(import.meta.env.VITE_API_BASE_URL, 'http://localhost:8787').replace(
  /\/$/,
  '',
);
const supabaseUrl = readEnv(import.meta.env.VITE_SUPABASE_URL);
const supabaseAnonKey = readEnv(import.meta.env.VITE_SUPABASE_ANON_KEY);
const devAuthFlag = readEnv(import.meta.env.VITE_DEV_AUTH_ENABLED, 'false');

/**
 * The development sign-in button is only rendered when the operator opts in
 * explicitly AND a Supabase project is not configured, so a misconfigured
 * production build cannot expose it.
 */
export const webConfig: WebConfig = {
  apiBaseUrl,
  supabaseUrl,
  supabaseAnonKey,
  devAuthEnabled: isTruthy(devAuthFlag),
  siteUrl: readEnv(import.meta.env.VITE_SITE_URL, window.location.origin).replace(/\/$/, ''),
  supabaseConfigured: Boolean(supabaseUrl && supabaseAnonKey),
};

export function configProblems(): string[] {
  const problems: string[] = [];
  if (!webConfig.apiBaseUrl) problems.push('VITE_API_BASE_URL is not set.');
  if (!webConfig.supabaseConfigured) {
    problems.push(
      'VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY are not set, so Google sign-in is unavailable.',
    );
  }
  return problems;
}
